<!--
 * @Author: 汪俊洪
 * @Date: 2021-10-19 15:41:18
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2023-10-26 17:33:23
 * @Description: 查看物流
-->
<template>
  <div v-if="list.length">
    <el-tabs v-model="activeName" v-if="list.length > 1" @tab-click="handleClick">
      <el-tab-pane
        :label="item.trackNum"
        v-for="(item, index) in list"
        :key="index"
        :name="item.trackNum"
      ></el-tab-pane>
    </el-tabs>
    <div class="wrap">
      <div class="info">
        <div class="item">
          <span class="label">物流公司：</span>
          <span class="value">{{ detail.trackCompany || '-' }}</span>
        </div>
        <div class="item">
          <span class="label">运单号：</span>
          <span class="value">{{ detail.trackNum || '-' }}</span>
        </div>
        <div class="item">
          <span class="label">收货地址：</span>
          <span class="value">{{ detail.shipAddr || '-' }}</span>
        </div>
      </div>
      <div
        class="list"
        v-if="detail.activityList && detail.activityList.length > 0"
      >
        <el-timeline>
          <el-timeline-item
            v-for="(item, index) in detail.activityList"
            :key="index"
            :type="index === 0 ? 'primary' : 'info'"
            :size="index === 0 ? 'large' : 'normal'"
            :timestamp="item.supconChangetime"
          >
            {{ item.eventdescription }}
          </el-timeline-item>
        </el-timeline>
      </div>
      <div class="no-data" v-else>
        暂无物流信息
      </div>
    </div>
  </div>
  <div class="no-data" v-else>
    暂无物流信息
  </div>
</template>

<script>
export default {
  props: {
    deliveryId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      list: [],
      activeName: '',
      detail: {}
    }
  },
  created () {
    this.getLogisticsInfo()
  },
  methods: {
    getLogisticsInfo () {
      if (!this.deliveryId) {
        this.list = []
        return
      }
      const params = {
        deliveryId: this.deliveryId
      }
      this.$http
        .get('/front/bpm/supcon-goods-delivery/logistics-information-list', {
          params
        })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.list = [...res.data]
          } else {
            this.list = []
          }
          if (this.list.length) {
            this.activeName = res.data[0].trackNum
            this.detail = res.data[0]
          }
        })
    },
    handleClick () {
      this.list.some((v) => {
        if (v.trackNum === this.activeName) {
          this.detail = v
          return true
        }
        return false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  padding-left: 38px;
}
.list {
  padding: 10px 0 0 2px;
  max-height: 200px;
  overflow: auto;
  .item {
    display: flex;
    padding: 4px 0;
    .time {
      width: 130px;
      color: #797979;
    }
    .context {
      flex: 1;
      color: #303133;
      padding-left: 12px;
    }
  }
}
.no-data {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #797979;
  border: 1px solid #e5e5e5;
  height: 100px;
}
.info {
  line-height: 28px;
  padding-bottom: 12px;
  .item {
    .label {
      color: #666;
    }
    .value {
      color: #333;
    }
  }
}
</style>
